<div class="custom-rule-dropdown-wrapper" [class.dropdown-open]="isOpen">
  <div class="custom-rule-dropdown" [class.disabled]="disabled" [class.dropdown-open]="isOpen">
    <div
      class="select-trigger"
      [class]="cssClass"
      [class.open]="isOpen"
      [attr.tabindex]="disabled ? -1 : 0"
      [attr.role]="'combobox'"
      [attr.aria-expanded]="isOpen"
      [attr.aria-haspopup]="'listbox'"
      [attr.aria-label]="placeholder"
      (click)="toggleDropdown()"
      (keydown)="onTriggerKeydown($event)"
    >
      <div class="selected-value" [class.placeholder]="!selectedValue">
        {{ selectedLabel }}
      </div>
      <div>
        <i class="fa-utility fa-semibold fa-angle-down dropdown-arrow" [class.rotated]="isOpen"></i>
      </div>
    </div>
  </div>
  <div #dropdownPanel class="dropdown-panel" *ngIf="isOpen" [class.open]="isOpen">
    <div class="search-container">
      <input
        #searchInput
        type="text"
        class="search-input arpio-input"
        [placeholder]="allowAddNew ? addNewPlaceholder : 'Search...'"
        [(ngModel)]="searchTerm"
        (input)="onSearchInput($event)"
        (keydown)="onSearchKeydown($event)"
      />
      <i class="fa-utility fa-semibold fa-magnifying-glass search-icon"></i>
    </div>

    <div class="options-container" role="listbox">
      <!-- Regular options -->
      <div
        *ngFor="let option of filteredOptions; trackBy: optionTrackBy"
        class="dropdown-option"
        [class.disabled]="option.disabled"
        [class.selected]="option.value === selectedValue"
        [class.temporary]="option.isTemporary"
        [attr.role]="'option'"
        [attr.aria-selected]="option.value === selectedValue"
        [attr.tabindex]="option.disabled ? -1 : 0"
        (click)="selectOption(option)"
        (keydown.enter)="selectOption(option)"
        (keydown.space)="selectOption(option)"
      >
        <span class="option-label">{{ option.label }}</span>
        <div class="option-actions" *ngIf="option.isTemporary">
          <span class="temp-indicator" title="custom option"></span>
          <button
            class="remove-option-btn"
            type="button"
            title="Remove custom option"
            (click)="removeCustomOption(option, $event)"
            (keydown.enter)="removeCustomOption(option, $event)"
            (keydown.space)="removeCustomOption(option, $event)"
          >
            <i class="fa-utility fa-semibold fa-xmark"></i>
          </button>
        </div>
      </div>

      <!-- Add new option -->
      <div *ngIf="showAddNewOption" class="dropdown-option add-new-option" (click)="addNewOption()">
        <i class="fa-utility fa-semibold fa-plus"></i>
        <span class="custom-option">Add "{{ searchTerm }}"</span>
      </div>

      <!-- No options message -->
      <div *ngIf="filteredOptions.length === 0 && !showAddNewOption" class="no-options">No options available</div>
    </div>
  </div>
</div>
